var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExportPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3453 5.345L12.9887 2.98833C12.6762 2.67583 12.252 2.5 11.8103 2.5H5.83366C4.91283 2.5 4.16699 3.24583 4.16699 4.16667V15.8333C4.16699 16.7542 4.91283 17.5 5.83366 17.5H14.167C15.0878 17.5 15.8337 16.7542 15.8337 15.8333V6.52333C15.8337 6.08167 15.6578 5.6575 15.3453 5.345V5.345Z",
    stroke: "#EF5B3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 6.66667H12.5003C12.0403 6.66667 11.667 6.29333 11.667 5.83333V2.5",
    stroke: "#EF5B3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6167 13.7917H11.3834",
    stroke: "#EF5B3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02783 10.6258V9.65246C9.02783 9.38413 9.24533 9.16663 9.51367 9.16663H10.487C10.7553 9.16663 10.9728 9.38413 10.9728 9.65246V10.6258C10.9728 10.8941 10.7553 11.1116 10.487 11.1116H9.51367C9.24533 11.1108 9.02783 10.8933 9.02783 10.6258Z",
    stroke: "#EF5B3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66699 14.5142V13.5409C6.66699 13.2726 6.88449 13.0551 7.15283 13.0551H8.12616C8.39449 13.0551 8.61199 13.2726 8.61199 13.5409V14.5142C8.61199 14.7826 8.39449 15.0001 8.12616 15.0001H7.15283C6.88449 15.0001 6.66699 14.7826 6.66699 14.5142Z",
    stroke: "#EF5B3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3896 14.5142V13.5409C11.3896 13.2726 11.6071 13.0551 11.8755 13.0551H12.8488C13.1171 13.0551 13.3346 13.2726 13.3346 13.5409V14.5142C13.3338 14.7826 13.1163 15.0001 12.848 15.0001H11.8746C11.6071 15.0001 11.3896 14.7826 11.3896 14.5142H11.3896Z",
    stroke: "#EF5B3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8667 13.0583L10.6084 11.0917",
    stroke: "#EF5B3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13379 13.0583L9.39212 11.0917",
    stroke: "#EF5B3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExportPdf);
export default ForwardRef;